import { authLocalDataService } from "./data";

const accessToken = authLocalDataService.getAccessToken();

const authService = {
  accessToken,
};

export default authService;
